// 商城组件
export const hmComponents = [
  {
    label: "图片广告",
    icon: "icon-tuwenxiangqing",
    type: "base",
    component: "image-ad-selection",
    prop: {
      name: "image-ad-selection",
      isSwiper: false,
      type: "1",
      imgList: [],
      borderRadius: false,
      margin: 0,
      marginBottom: 0,
      leftImgList: [],
      rightImgList: [],
      rightImgList2: [],
    }
  },
  {
    label: "顶部广告",
    icon: "icon-tuwenxiangqing",
    type: "base",
    component: "image-ad-selection-plus",
    prop: {
      name: "image-ad-selection-plus",
      isSwiper: false,
      type: "1",
      imgList: [],
      borderRadius: false,
      margin: 0,
      marginBottom: 0,
      leftImgList: [],
      rightImgList: []
    }
  },
  {
    label: "商品搜索",
    icon: "icon-shangpinsousuo",
    type: "base",
    component: "search",
    prop: {
      name: "search",
      radius: false,
      version: "Horizontal",
      versionSrc: "",
      wrapperBackGround: "#fff",
      hotWordList: [],
      placeholder: "",
      height: 40,
      background: "#f0f0f0",
      color: "#2B2B2B",
      searchMode: "keyWord"
    }
  },
  {
    label: "商品分类",
    icon: "icon-shangpinfenlei",
    type: "base",
    component: "tabs",
    prop: {
      name: "tabs",
      tabList: [],
      type: "text",
      layout: "flex-start",
      backgroundColor: "#f0f0f0",
      color: "#2B2B2B",
      goodShowType: "twoColumn",
    }
  },
  {
    label: "热销活动",
    icon: "icon-rexiaohuodong",
    type: "base",
    component: "hot",
    prop: {
      name: "hot",
      hotList: [],
      type: "text",
      layout: "flex-start",
      imgList: [],
      hotImg:
          "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png"
    }
  },
  {
    label: "图片热区",
    icon: "icon-tupianrequ",
    type: "base",
    component: "hotZone",
    prop: {
      name: "hotZone",
      isActive: true,
      zones: [],
      zonesInit: [],
      image:
        "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png"
    }
  },
  {
    label: "商品排列",
    icon: "icon-shangpinpailie",
    type: "base",
    component: "goodsList",
    prop: {
      name: "goodsList",
      showSubTitle: true,
      showPrice: true,
      showCart: true,
      showLogo: true,
      showSubPrice: false,
      titleBold: false,
      borderRadius: false,
      padding: 5,
      marginBottom: 5,
      goodShowType: "big",
      logoType: "HOT",
      logoUrl: "",
      goodsList: [
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        }
      ]
    }
  },
  {
    label: "图文导航",
    icon: "icon-tuwendaohang",
    type: "base",
    component: "image-text-nav",
    prop: {
      name: "image-text-nav",
      backgroundColor: "#fff",
      color: "#2b2b2b",
      imageTextNavList: [
        {
          goodsInfo: {},
          hrefAddress: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          activityInfo: {},
          liveList: [],
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航一",
          groupGoods: {}
        },
        {
          goodsInfo: {},
          hrefAddress: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          activityInfo: {},
          liveList: [],
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航二",
          groupGoods: {}
        },
        {
          goodsInfo: {},
          hrefAddress: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          activityInfo: {},
          liveList: [],
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航三",
          groupGoods: {}
        },
        {
          goodsInfo: {},
          hrefAddress: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          activityInfo: {},
          liveList: [],
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航四",
          groupGoods: {}
        }
      ]
    }
  },
  {
    label: "标题文本",
    icon: "icon-biaotiwenzi",
    type: "base",
    component: "title-text",
    prop: {
      name: "title-text",
      isShowMore: false,
      titleBold: false,
      subTitleBold: false,
      titleColor: "#2b2b2b",
      subTitleColor: "#969799",
      backgroundColor: "#fff",
      hrefAddress: "",
      goodsInfo: {},
      appid: "",
      title: "",
      subTitle: "",
      groupGoods: {},
      isShowCopyBtn: false,
      profile: "",
      activity: "",
      roomId: "",
      liveList: [],
      activityInfo: {},
    }
  },
  {
    label: "富文本",
    icon: "icon-fuwenben",
    type: "base",
    component: "rich-text",
    prop: {
      name: "rich-text",
      content: ""
    }
  },
  {
    label: "魔方",
    icon: "icon-mofang",
    type: "base",
    component: "cube",
    prop: {
      name: "cube",
      permutation: 2,
      itemMargin: 0,
      margin: 0,
      cubeList: [
        {
          hrefAddress: "",
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          liveList: [],
          activityInfo: {},
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          goodsInfo: {},
          url: "",
          groupGoods: {}
        },
        {
          goodsInfo: {},
          appid: "",
          profile: "",
          activity: "",
          roomId: "",
          liveList: [],
          activityInfo: {},
          hrefAddress: "",
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          url: "",
          groupGoods: {}
        }
      ]
    }
  },
  {
    label: "辅助分割",
    icon: "icon-fengexian",
    type: "base",
    component: "dividing-line",
    prop: {
      name: "dividing-line",
      line: false, // 控制显示空白还是边框线
      blankHeight: 30,
      borderColor: "#e5e5e5"
    }
  },
  {
    label: "视频",
    icon: "icon-shipin",
    type: "base",
    component: "video",
    prop: {
      name: "video",
      src: "",
      type: "origin"
    }
  },
  {
    label: "公告",
    icon: "icon-gonggao",
    type: "base",
    component: "notice",
    prop: {
      name: "notice",
      text: "",
      color: "#de8c17",
      backgroundColor: "#fffbe8",
      fixedBottom: false,
      isShowClickButton: false,
      clickButtonTitle: "",
      hrefAddress: "",
      isShowCloseButton: false,
      scrollable: false,
      textCenter: false,
      titleBold: false
    }
  },
  {
    label: "客服",
    icon: "icon-kefu",
    type: "base",
    component: "contact-us",
    prop: {
      name: "contact-us",
      text: "在线咨询",
      type: "link",
      url: "",
      src: ""
    }
  },
  {
    label: "猜你喜欢",
    icon: "icon-cainixihuan",
    type: "base",
    component: "guess-you-like",
    prop: {
      name: "guess-you-like",
      showSubTitle: true,
      showPrice: true,
      showCart: true,
      showLogo: true,
      showSubPrice: false,
      titleBold: false,
      borderRadius: false,
      padding: 5,
      marginBottom: 5,
      goodShowType: "big",
      logoType: "HOT",
      logoUrl: "",
      goodsList: [
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        },
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 2,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        },
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 3,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        },
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 4,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        }
      ]
    }
  },
  {
    label: "plus卡片",
    icon: "icon-tuwenxiangqing",
    type: "base",
    component: "plus-card-more",
    prop: {
      name: "plus-card-more",
      type: "1",
      imgList: [],
    }
  },
  {
    label: "优惠券",
    icon: "icon-youhuiquan",
    type: "marketing",
    component: "coupon",
    prop: {
      name: "coupon",
      type: "1",
      title: "",
      titleVisible: true,
      secTitle: "",
      secTitleVisible: true,
      fillBgType: "custom",
      color: "#2b2b2b",
      bg: "",
      couponColorType: "default",
      couponColor: "",
      couponList: []
    }
  },
  {
    label: "拼团",
    icon: "icon-pintuan",
    type: "marketing",
    component: "groupon",
    prop: {
      name: "groupon",
      type: "1",
      title: "",
      titleVisible: true,
      secTitle: "",
      secTitleVisible: true,
      fillBgType: "custom",
      bg: "",
      color: "#2b2b2b",
      grouponList: [],
      titleBold: false,
      borderRadius: false,
      padding: 15
    }
  },
  {
    label: "秒杀",
    icon: "icon-miaosha",
    type: "marketing",
    component: "seckill",
    prop: {
      name: "seckill",
      type: "1",
      title: "",
      titleVisible: true,
      secTitle: "",
      color: "#2b2b2b",
      secTitleVisible: true,
      fillBgType: "custom",
      bg: "",
      seckillList: [],
      titleBold: false,
      borderRadius: false,
      padding: 15
    }
  },
  {
    label: "砍价",
    icon: "icon-kanjia",
    type: "marketing",
    component: "bargain",
    prop: {
      name: "bargain",
      type: "1",
      title: "",
      titleVisible: true,
      color: "#2b2b2b",
      secTitle: "",
      secTitleVisible: true,
      fillBgType: "custom",
      bg: "",
      bargainList: [],
      titleBold: false,
      borderRadius: false,
      padding: 15
    }
  },
  {
    label: "单人单次专享",
    icon: "icon-pinpaizhuanxiang",
    type: "marketing",
    component: "single-exclusive",
    prop: {
      name: "single-exclusive",
      type: "1",
      title: "",
      titleVisible: true,
      secTitle: "",
      color: "#2b2b2b",
      secTitleVisible: true,
      fillBgType: "custom",
      bg: "",
      singleExclusiveList: [],
      titleBold: false,
      borderRadius: false,
      padding: 15
    }
  },
  {
    label: "直播",
    icon: "icon-02f",
    type: "marketing",
    component: "live",
    prop: {
      name: "live",
      type: "1",
      title: "",
      titleVisible: true,
      secTitle: "",
      secTitleVisible: true,
      liveList: [],
      titleBold: false,
      borderRadius: false,
      padding: 15
    }
  },
  {
    label: "每日特惠",
    icon: "icon-meiritehui",
    type: "marketing",
    component: "dailydeals",
    prop: {
      name: "dailydeals",
      title: "每日特惠",
      showTitle: true,
      titlePic:"",
      showTitlePic: false,
      subTitle: "",
      showSubTitleTop: false,
      titleBold: false,
      subTitleBoldTop: false,
      titleColor: "#2b2b2b",
      subTitleColor: "#969799",
      backgroundColor: "#fff",
      borderRadius: false,
      padding: 5,
      marginBottom: 5,
      goodShowType: "big",
      goodShowType2:"add",
      groupGoods: [],
      interval:3,
      goodsList2:[],
      hrefAddress: "/pages/product/list?from=dailydeals",
      showGroupGoods: false,
      goodsList: [
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        }
      ]
    }
  },
  {
    label: "新品专区",
    icon: "icon-xinpinzhuanqu",
    type: "marketing",
    component: "dailynews",
    prop: {
      name: "dailynews",
      title: "新品专区",
      showTitle: true,
      titlePic:"",
      showTitlePic: false,
      subTitle: "",
      showSubTitleTop: false,
      titleBold: false,
      subTitleBoldTop: false,
      titleColor: "#2b2b2b",
      subTitleColor: "#969799",
      backgroundColor: "#fff",
      borderRadius: false,
      padding: 5,
      marginBottom: 5,
      goodShowType: "big",
      goodShowType2:"add",
      groupGoods: [],
      interval:3,
      goodsList2:[],
      goodsList: [
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        }
      ]
    }
  },
  {
    label: "组合活动",
    icon: "icon-meiritehui",
    type: "marketing",
    component: "composite",
    prop: {
      name: "composite",
      titleDailyDeals: "每日特惠",
      showTitleDailyDeals: false,
      titlePicDailyDeals:"https://imgcdn.hemiao100.com/hemiaoBase/composite_pic05.png",
      showTitlePicDailyDeals: true,
      subTitleDailyDeals: "",
      showSubTitleTopDailyDeals: false,
      titleBold: false,
      subTitleBoldTop: false,
      subTitleTextAlign: false,
      titleColor: "#2b2b2b",
      subTitleColor: "#969799",
      backgroundColor: "#fff",
      borderRadius: false,
      padding: 5,
      marginBottom: 5,
      goodShowType: "left",
      goodShowType2:"add",
      goodShowType3:"add",
      showGroupGoods: false,
      groupGoods: [],
      interval:3,
      hrefAddress: "/pages/product/list?from=dailydeals",
      goodsList2:[],
      goodsList: [
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        },
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        }
      ],
      titleDailyNews: "新品专区",
      showTitleDailyNews: false,
      titlePicDailyNews:"https://imgcdn.hemiao100.com/hemiaoBase/composite_pic06.png",
      showTitlePicDailyNews: true,
      subTitleDailyNews: "",
      showSubTitleTopDailyNews: false,
      goodsList4:[],
      goodsList3: [
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        },
        {
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        }
      ]
    }
  }
  // ,
  // {
  //   label: "接龙活动",
  //   icon: "icon-meiritehui",
  //   type: "marketing",
  //   component: "jielong",
  //   prop: {
  //     name: "jielong",
  //     title: "接龙活动",
  //     listLimit: 10,
  //   }
  // },
];

// 报表组件1
export const reportFormComponents = [
  {
    label: "表格",
    icon: "icon-biaoge",
    type: "base",
    component: "table-chart",
    prop: {
      configId: "",
      name: "table-chart",
      header: [],
      data: [],
      tableConditions: [],
      moduleName: "",
      subTitle: "",
      showModuleName: true,
      showSubTitle: true,
      disableDeleteBtn: true,
      showTableHeader: true
    }
  },
  {
    configId: "",
    label: "饼图",
    icon: "icon-bingtu",
    type: "base",
    component: "pie-chart",
    moduleName: "",
    subTitle: "",
    prop: {
      name: "pie-chart",
      groupNameList: [],
      groupValueList: [],
      data: [],
      tableConditions: [],
      moduleName: "",
      subTitle: "",
      showModuleName: true,
      showSubTitle: true,
      disableDeleteBtn: true,
      showTableHeader: true
    }
  },
  {
    label: "柱状图",
    icon: "icon-zhuzhuangtu",
    type: "base",
    component: "bar-chart",
    moduleName: "",
    subTitle: "",
    prop: {
      configId: "",
      name: "bar-chart",
      tableConditions: [],
      data: [],
      moduleName: "",
      subTitle: "",
      xAxisData: [],
      yAxisData: [],
      showModuleName: true,
      showSubTitle: true,
      disableDeleteBtn: true,
      showTableHeader: true,
      recovery: false
    }
  },
  {
    label: "折线图",
    icon: "icon-zhexiantu",
    type: "base",
    component: "line-chart",
    moduleName: "",
    subTitle: "",
    prop: {
      configId: "",
      name: "line-chart",
      tableConditions: [],
      data: [],
      moduleName: "",
      subTitle: "",
      xAxisData: [],
      yAxisData: [],
      showModuleName: true,
      showSubTitle: true,
      disableDeleteBtn: true,
      showTableHeader: true
    }
  },
  {
    label: "图片广告",
    icon: "icon-tuwenxiangqing",
    type: "base",
    component: "image-ad-selection",
    prop: {
      configId: "",
      name: "image-ad-selection",
      isSwiper: false,
      dotType: "circle",
      type: "1",
      data: [],
      imgList: [],
      borderRadius: false,
      margin: 0,
      marginBottom: 0,
      leftImgList: [],
      rightImgList: []
    }
  },
  {
    label: "标题文本",
    icon: "icon-biaotiwenzi",
    type: "base",
    component: "title-text",
    prop: {
      name: "title-text",
      isShowMore: false,
      titleBold: false,
      subTitleBold: false,
      titleColor: "#2b2b2b",
      subTitleColor: "#969799",
      backgroundColor: "#fff",
      hrefAddress: "",
      goodsInfo: {},
      title: "",
      subTitle: "",
      groupGoods: {},
      isShowCopyBtn: false
    }
  }
];

// 报表组件2
export const reportConfigComponents = [
  {
    label: "图片广告",
    icon: "icon-tuwenxiangqing",
    type: "base",
    component: "image-ad-selection",
    prop: {
      name: "image-ad-selection",
      isSwiper: false,
      type: "1",
      data: [],
      imgList: [],
      borderRadius: false,
      margin: 0,
      marginBottom: 0,
      leftImgList: [],
      rightImgList: []
    }
  },
  {
    label: "标题文本",
    icon: "icon-biaotiwenzi",
    type: "base",
    component: "title-text",
    prop: {
      name: "title-text",
      isShowMore: false,
      titleBold: false,
      subTitleBold: false,
      titleColor: "#2b2b2b",
      subTitleColor: "#969799",
      backgroundColor: "#fff",
      hrefAddress: "",
      goodsInfo: {},
      title: "",
      subTitle: "",
      groupGoods: {},
      isShowCopyBtn: false
    }
  }
];

// 导购助手组件
export const guiderComponents = [
  {
    label: "会员卡累计消费",
    icon: "icon-huiyuanleijixiaofei",
    type: "custom",
    component: "consumption-range",
    prop: {
      name: "consumption-range",
      isSwiper: false,
      title: "",
      isOpen: true,
      consumRange: [],
      isOpenBaseText: true,
      baseText: ""
    }
  },
  {
    label: "公告",
    icon: "icon-gonggao",
    type: "base",
    component: "notice",
    prop: {
      iconImage:
        "https://imgcdn.hemiao100.com/guide/ps26905e31dbdbafad-b655-4500-ba2a-d8958a9de3c0.png",
      name: "notice",
      text: "",
      color: "#2b2b2b",
      backgroundColor: "#fff"
    }
  },
  {
    label: "广告位",
    component: "banner",
    prop: {
      name: "banner",
      imgList: []
    }
  },
  {
    label: "我的服务",
    component: "myService",
    prop: {
      name: "myService",
      isVertical: false,
      fontSizeType: "normal",
      serviceList: []
    }
  }
];

// 商城导航栏
export const tabBarList = [
  {
    hrefName: "首页",
    open: true,
    hrefAddress: "/pages/index/index",
    custom: false,
    iconPath:
      "https://imgcdn.hemiao100.com/hemiaoBase/8d8820fc-09eb-4d5b-8c1c-b45964d78469.png",
    selectedIconpath:
      "https://imgcdn.hemiao100.com/hemiaoBase/5cd6563e-9c50-4bc5-8c14-bb8d20e12e5a.png",
    groupGoods: {}
  },
  {
    hrefName: "分类",
    open: true,
    hrefAddress: "/pages/category/category",
    custom: true,
    iconPath:
      "https://imgcdn.hemiao100.com/hemiaoBase/1fb35303-9cd7-4e1d-9e43-8fc5035b2fa2.png",
    selectedIconpath:
      "https://imgcdn.hemiao100.com/hemiaoBase/7f97495f-032d-4464-8d7b-a31959ce5ee5.png",
    groupGoods: {}
  },
  {
    hrefName: "购物车",
    open: true,
    hrefAddress: "/pages/cart/cart",
    custom: false,
    iconPath:
      "https://imgcdn.hemiao100.com/hemiaoBase/777cc4d8-7094-4354-b6cf-905809265dba.png",
    selectedIconpath:
      "https://imgcdn.hemiao100.com/hemiaoBase/bf32e743-8270-4212-91a3-19266fef457b.png",
    groupGoods: {}
  },
  {
    hrefName: "我的",
    open: true,
    hrefAddress: "/pages/user/user",
    url: "/pages/user/user",
    custom: false,
    iconPath:
      "https://imgcdn.hemiao100.com/hemiaoBase/465313af-f0f4-49f2-b178-177beca76d15.png",
    selectedIconpath:
      "https://imgcdn.hemiao100.com/hemiaoBase/8e343516-81e9-477d-9f9e-cd49054e52bf.png",
    groupGoods: {}
  }
];

export const predefine = [
  "#ffffff",
  "#f8f8f8",
  "#f2f2f2",
  "#999999",
  "#444444",
  "#ff4444",
  "#e50065",
  "#ff6500",
  "#ff884d",
  "#ffcd00",
  "#3fbd00",
  "#3fbcb7",
  "#00cd98",
  "#5197ff",
  "#badcff",
  "#ffefb8",
  "#EDE7AC"
];

export const beltTempList = [
  {
    templateType: "model1",
    bg:
      "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1584008155514-7d5268d7-f54f-4e0a.png",
    tempImg:
      "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/background1.png",
    textList: [
      {
        title: "惊爆价",
        titleFontWeight: "normal",
        titleColor: "#FF3156",
        titleFontSize: 16,
        contentType: "",
        contentFontWeight: "normal",
        contentColor: "#FF3156",
        contentFontSize: 16,
        show: true
      },
      {
        title: "活动时间：",
        titleFontWeight: "normal",
        titleColor: "#fff",
        titleFontSize: 14,
        contentType: "timeRange",
        contentFontWeight: "normal",
        contentColor: "#fff",
        contentFontSize: 14,
        show: true
      },
      {
        title: "",
        titleFontWeight: "normal",
        titleColor: "#FF3156",
        titleFontSize: 30,
        contentType: "discountPrice",
        contentFontWeight: "normal",
        contentColor: "#FF3156",
        contentFontSize: 30,
        show: true
      },
      {
        title: "限时下单第二件半价",
        titleFontWeight: "normal",
        titleColor: "#fff",
        titleFontSize: 18,
        contentType: "",
        contentFontWeight: "normal",
        contentColor: "#fff",
        contentFontSize: 18,
        show: true
      }
    ]
  },
  {
    templateType: "model2",
    bg:
      "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1584008177858-11225bb2-f01b-420a.png",
    tempImg:
      "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1584009366421-033569de-699c-4bd7.png",
    textList: [
      {
        title: "双十一全场大促",
        titleFontWeight: "normal",
        titleColor: "#fff",
        titleFontSize: 28,
        contentType: "",
        contentFontWeight: "normal",
        contentColor: "#fff",
        contentFontSize: 28,
        show: true
      },
      {
        title: "限时特惠",
        titleFontWeight: "normal",
        titleColor: "#fff",
        titleFontSize: 26,
        contentType: "",
        contentFontWeight: "normal",
        contentColor: "#fff",
        contentFontSize: 26,
        show: true
      },
      {
        title: "活动不打烊",
        titleFontWeight: "normal",
        titleColor: "#fff",
        titleFontSize: 18,
        contentType: "",
        contentFontWeight: "normal",
        contentColor: "#fff",
        contentFontSize: 18,
        show: true
      },
      {
        title: "距离结束仅剩：",
        titleFontWeight: "normal",
        titleColor: "#EDE7AC",
        titleFontSize: 12,
        contentType: "countDown",
        contentFontWeight: "normal",
        contentColor: "#EDE7AC",
        contentFontSize: 12,
        show: true
      }
    ]
  }
];
